<header id="header">
    <div class="inner">
       <img src="./../../../assets/images/logo_pdf.png" class="mt-1">
        <nav id="nav">
            <a href="https://www.autoconfig.cloud/home">Home</a>
            <a href="https://www.autoconfig.cloud/services">Services</a>
            <a href="https://www.autoconfig.cloud/solution">Solutions</a>
            <a href="https://www.autoconfig.cloud/casestudies">Case Studies</a>
            <a href="#">Lets Connect</a>
            <a href="#" (click)='logout()' *ngIf="isLogedin">Sign out</a>
            <a href="../login"  *ngIf="!isLogedin">Sign in</a>
            <a href="https://www.autoconfig.cloud/contactus">Contact Us</a>
        </nav>
    </div>
</header>
<a href="#menu" class="navPanelToggle"><span class="fa fa-bars"></span></a>
